import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IOfferChallengeProduct } from '@/shared/model/offer-challenge-product.model';

const baseApiUrl = 'api/offer-challenge-products';
const baseSearchApiUrl = 'api/_search/offer-challenge-products?query=';

export default class OfferChallengeProductService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IOfferChallengeProduct> {
    return new Promise<IOfferChallengeProduct>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IOfferChallengeProduct): Promise<IOfferChallengeProduct> {
    return new Promise<IOfferChallengeProduct>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IOfferChallengeProduct): Promise<IOfferChallengeProduct> {
    return new Promise<IOfferChallengeProduct>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
